import classNames from 'classnames';

import React, { PureComponent } from 'react';

import Icon, { ICON_TYPES } from '@commons/Icon';

import styles from './uploaderror.scss';
import { getTranslation } from '@services/translations';

const DEFAULT_CLOST_TEXT = "Close";

interface UploadErrorProps {
  file: {
    [key: string]: any;
  };
  onFileError: (...args: unknown[]) => unknown;
}

export default class UploadError extends PureComponent<UploadErrorProps> {
  constructor(props) {
    super(props);
    this.handleFileError = this.handleFileError.bind(this);
  }

  handleFileError(e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onFileError(this.props.file);
  }

  render() {
    const { file } = this.props;
    const containerStyle = classNames(styles.container, styles.containerError);
    const closeButtonLabel = getTranslation('TA_CLOSE', DEFAULT_CLOST_TEXT);

    return (
      <li className={containerStyle}>
        {/* Added `role="alert"`  to ensure JAWS announces file upload errors. */}
        <span className={styles.errorMessage} id={`errorMessage-${file.order}`}>{file.errorMessage}</span>
        <button aria-label={closeButtonLabel} aria-describedby={`errorMessage-${file.order}`} className={styles.closeButton} onClick={this.handleFileError}>
          <Icon type={ICON_TYPES.CLOSE} containerStyles={styles.closeIcon} />
        </button>
      </li>
    );
  }
}
